import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { persistor } from "../../app/store/store";

export const ProtectedLayout = () => {
  const isAuth = useSelector((state) => state.app.isAuth);
  const role = useSelector((state) => state.app.role);
  const accessToken = useSelector((state) => state.app.accessToken);

  if (!isAuth && !role && !accessToken) {
    persistor.purge();
    return <Navigate to="/login" />;
  } else {
    return <Outlet />;
  }
};
